(function ($) {
	class W4D_ProductFlyout {
		constructor() {
			this.bindEvents();
			this.currentProductId = null;
			this.lightGalleryAssets = null;
			// Bumped by every open and by close: a response for an older open is ignored.
			this.request = 0;
		}

		bindEvents() {
			// First cell is an <a>, so it can't use invoker commands: open via JS.
			$(document).on('click', '.product-table [role="row"] > [role="cell"]:first-child', (e) => {
				if (e.ctrlKey) {
					return true; // Open in new tab
				}
				e.preventDefault();
				this.openFor(e.currentTarget);
			});

			// "Vidi opcije" button fires the custom command declaratively (command="--show");
			// we react to it to open the dialog non-modally and load its content.
			document.addEventListener(
				'command',
				(e) => {
					if (e.command === '--show-dialog') {
						// Same path as the first-cell click: the flyout's gallery needs lightGallery loaded first.
						this.openFor(e.source);
					}
				},
				{ capture: true }
			);

			// Reset when the dialog closes (invoker "close" button, closedby="any", or Esc).
			// We use { capture: true } because native close events on <dialog> elements do not bubble.
			document.addEventListener(
				'close',
				(e) => {
					if (e.target && e.target.id === 'product-flyout') {
						this.onClose();
					}
				},
				{ capture: true }
			);

			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') {
					const dialog = document.getElementById('product-flyout');
					if (dialog && dialog.open) {
						dialog.close();
					}
				}
			});

			$(document).on('click', '.w4d_update_cart_button', (e) => W4D_Cart.handleUpdateCart($(e.currentTarget)));
		}

		openFor(trigger) {
			const dialog = document.getElementById('product-flyout');
			if (!dialog) return;

			const productId = $(trigger).closest('[role="row"]').data('product-id');

			// Same product already open -> just close.
			if (dialog.open && this.currentProductId === productId) {
				dialog.close();
				return;
			}

			if (!dialog.open) {
				dialog.show();
			}

			// Slide in with the loader right away; the product request runs while lightGallery loads (on shop pages
			// it is not enqueued, so the first open loads it here).
			const request = ++this.request;
			const sidebar = $(dialog);
			sidebar.addClass('product-flyout--active is-loading');
			sidebar.find('.product-flyout__content').empty();

			const assets = this.loadLightGalleryAssets().catch((error) => {
				// Retry the assets on the next open; the product still loads, without the gallery lightbox.
				this.lightGalleryAssets = null;
				console.warn('W4D_ProductFlyout: lightGallery could not be loaded', error);
			});
			const html = Promise.resolve(
				$.ajax({
					url: w4d_frontend_ajax.ajax_url,
					data: {
						action: 'get_product_sidebar_html',
						nonce: w4d_frontend_ajax.nonce,
						product_id: productId,
					},
				})
			).catch(() => null);

			Promise.all([html, assets]).then(([response]) => {
				// Closed (Esc, close button) or replaced by another row meanwhile.
				if (request !== this.request || !dialog.open) return;
				this.showContent(sidebar, productId, response);
			});
		}

		loadLightGalleryAssets() {
			if (this.lightGalleryAssets) {
				return this.lightGalleryAssets;
			}

			const themeUrl = window.w4d_frontend_ajax?.theme_url;
			if (!themeUrl) {
				return Promise.reject(new Error('LightGallery theme URL is unavailable.'));
			}

			const baseUrl = `${themeUrl}/assets/libs/light-gallery`;
			const styles = [`${baseUrl}/lightgallery-bundle.min.css`, `${baseUrl}/lg-video.min.css`, `${baseUrl}/lg-autoplay.css`];
			const scripts = [
				`${baseUrl}/lightgallery.min.js`,
				`${baseUrl}/lg-thumbnail.umd.min.js`,
				`${baseUrl}/lg-zoom.umd.min.js`,
				`${baseUrl}/lg-video.min.js`,
				`${baseUrl}/lg-autoplay.min.js`,
			];

			// Already on the page also when WordPress enqueued it (src/href with ?ver=...).
			const isLoaded = (selector, url) => document.querySelector(`${selector}="${url}"], ${selector}^="${url}?"]`);

			// A failed tag is removed, so the next open really loads it again instead of treating it as loaded.
			const settle = (element, resolve, reject) => {
				element.onload = resolve;
				element.onerror = (error) => {
					element.remove();
					reject(error);
				};
			};

			const appendStyle = (url) => {
				if (isLoaded('link[href', url)) return Promise.resolve();

				return new Promise((resolve, reject) => {
					const link = document.createElement('link');
					link.rel = 'stylesheet';
					link.href = url;
					settle(link, resolve, reject);
					document.head.appendChild(link);
				});
			};

			const appendScript = (url, index) => {
				if (isLoaded('script[src', url)) return Promise.resolve();

				return new Promise((resolve, reject) => {
					const script = document.createElement('script');
					script.src = url;
					script.async = false;
					script.dataset.w4dLightGallery = String(index);
					settle(script, resolve, reject);
					document.head.appendChild(script);
				});
			};

			this.lightGalleryAssets = Promise.all(styles.map(appendStyle)).then(() =>
				scripts.reduce((promise, url, index) => promise.then(() => appendScript(url, index)), Promise.resolve())
			);

			return this.lightGalleryAssets;
		}

		onClose() {
			const sidebar = $('#product-flyout');
			const content = sidebar.find('.product-flyout__content');

			sidebar.removeClass('product-flyout--active is-loading');
			content.empty();
			this.currentProductId = null;
			this.request++;
		}

		showContent(sidebar, productId, response) {
			sidebar.removeClass('is-loading');
			if (!response || !response.success) return;

			sidebar.find('.product-flyout__content').html(response.data);
			this.currentProductId = productId;
			window.W4D_Cart.handleVariationChange();
			window.W4D_FormBuilder.initValidation();
			if (window.w4d && window.w4d.product_gallery && typeof window.lightGallery === 'function') {
				window.w4d.product_gallery.init(sidebar[0]);
			}
		}
	}

	$(document).ready(() => {
		new W4D_ProductFlyout();
	});
})(jQuery);
